import { info, } from 'application/console';
import { SELECTORS, } from 'config/preRenderedSelectorsConfig';
import { createElement, addElementAfter, node, } from 'utils/dom';


const INSERTION_ELEMENT_SELECTOR = 'p[data-label]';
const INSERTION_ELEMENT_SELECTOR_FALLBACK = 'p';
const INSERTION_ELEMENT_NUMBER = 2;
const INJECTED_ELEMENT_DEFAULTS = {
  tagName: 'div',
  className: '',
  dataset: {},
};


function getSelectorMatches(scopeEl, selector){
  return scopeEl && scopeEl.querySelectorAll(selector);
}

export function injectElement(elementConf = {}, log){
  const postBodyNode = node(SELECTORS.POST_BODY_SELECTOR);
  const postBodySelectorMatches = getSelectorMatches.bind(postBodyNode, postBodyNode);
  let selectorMatches = postBodySelectorMatches(INSERTION_ELEMENT_SELECTOR);
  if (selectorMatches && selectorMatches.length < INSERTION_ELEMENT_NUMBER) {
    const currentSelector = INSERTION_ELEMENT_SELECTOR_FALLBACK;
    selectorMatches = postBodySelectorMatches(currentSelector);
  }
  if (selectorMatches && selectorMatches.length >= INSERTION_ELEMENT_NUMBER) {
    const injectAfterNode = selectorMatches[INSERTION_ELEMENT_NUMBER - 1];
    const { tagName, className, dataset, } = Object.assign({}, INJECTED_ELEMENT_DEFAULTS, elementConf);
    const injectedEl = createElement(tagName);
    injectedEl.className = className;
    Object.assign(injectedEl.dataset, dataset);
    addElementAfter(injectedEl, injectAfterNode);
    log('Adding', { injectedEl, injectAfterNode, selectorMatches, });
    return true;
  }
  log('Skipping', { elementConf, selectorMatches, });
  return false;
}

export function logger(shouldLog, ...messages){
  shouldLog && info(...messages);
}


// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/application/injectDynamicContent.js